import { createUseStyles } from 'react-jss'

export default createUseStyles((theme) => ({
    AppEntry: {
        extend: theme.CONTAINER_100x100,
        background: theme.colors.background,
    },
}))
